// extracted by mini-css-extract-plugin
export var addToCartButton = "_ty-b";
export var arrowButtonContainer = "_ty-9";
export var arrowButtonIcon = "_ty-a";
export var carouselArrowButton = "_ty-6";
export var carouselElementContainer = "_ty-1";
export var left = "_ty-7";
export var productDisplayCarouselContainer = "_ty-0";
export var productTileContainer = "_ty-2";
export var productTileImage = "_ty-4";
export var productTileImageContainer = "_ty-3";
export var productTileTitle = "_ty-5";
export var right = "_ty-8";
export var sliderOverflow = "_ty-c";